import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

const FIELDS = [
  ['business_name', 'Business legal name', 'e.g. Doe Holdings LLC'],
  ['business_address', 'Business address', 'Street, City, State ZIP'],
  ['ein_last4', 'EIN — last 4 digits', '1234'],
  ['duns', 'D-U-N-S number', '9 digits'],
  ['representative_name', 'Authorized representative', 'Defaults to the client name'],
  ['representative_title', 'Title', 'e.g. Owner, Managing Member, CEO'],
];

// Opens only for the Business Account Removal letter. Every field is optional — blanks stay as [PLACEHOLDERS] on the letter.
export default function BusinessInfoDialog({ open, value, onSave, onClose }) {
  const [form, setForm] = useState(value || {});
  useEffect(() => { if (open) setForm(value || {}); }, [open, value]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: k === 'ein_last4' ? e.target.value.replace(/\D/g, '').slice(0, 4) : e.target.value }));
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="business-info-dialog">
        <DialogTitle>Business information</DialogTitle>
        <DialogDescription>Fill in what you have — anything left blank won't stop you. You'll type each account's dispute reason on the review step.</DialogDescription>
        <div className="space-y-2">
          {FIELDS.map(([k, label, ph]) => (
            <label key={k} className="block text-xs font-semibold text-slate-600">
              {label}
              <input value={form[k] || ''} onChange={set(k)} placeholder={ph} inputMode={k === 'ein_last4' ? 'numeric' : undefined}
                className="mt-0.5 w-full rounded-md border border-slate-300 px-2 py-1.5 text-sm text-slate-900" data-testid={`business-${k}`} />
            </label>
          ))}
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={() => { onSave(form); onClose(); }} className="rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white" data-testid="business-info-continue">
            Continue
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
